const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/allowedAppointmentTypes.ts';
import { IActionHandlersMap, KisApiAction, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { addRequestActionHandlers, getData, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { PatAppStoreState } from './setup/rootReducer';
import {
    loadAllowedAppointmentTypes,
    REQUEST_ACTION_TYPES_ALLOWED_APPOINTMENT_TYPES,
} from 'App/actions/allowedAppointmentTypes';
import { createSelector } from 'reselect';

const handlers: IActionHandlersMap = {};

const appointmentTypeDataProcessorFunction = (action: KisApiAction, state?: ReducerState) => {
    return (action.payload.CONTENT.Termintypen as string).split(',');
};

addRequestActionHandlers(
    handlers,
    REQUEST_ACTION_TYPES_ALLOWED_APPOINTMENT_TYPES,
    undefined,
    appointmentTypeDataProcessorFunction
);

export const allowedAppointmentTypesReducer = makeReducer(handlers);

// SELECTORS
/*

export const selectAllowedAppointmentTypes = (state: PatAppStoreState): AppointmentType[] =>
    getData(state.allowedAppointmentTypes) || [];
*/

const selectAllowedAppointmentTypesState = (state: PatAppStoreState) => state.allowedAppointmentTypes;

export const selectAllowedAppointmentTypes = createSelector(
    [selectAllowedAppointmentTypesState],
    allowed => getData(allowed) || []
);

// HOOKS

export function useAllowedAppointmentTypes() {
    return useRemoteData2('allowedAppointmentTypes', {
        request: dispatch => dispatch(loadAllowedAppointmentTypes()),
        select: selectAllowedAppointmentTypes,
    });
}
